import { useEffect } from 'react';

import { PageLoader } from '@/shared/components/loader/page-loader';

export function MicrosoftCallbackPage() {
  useEffect(() => {
    // This page is loaded in the popup after Microsoft authentication
    // The parent window will read the URL parameters from this page
    // No need to do anything here - the parent handles everything
  }, []);

  return <PageLoader />;
}
